import React from 'react';
import { Card, Row, Col, Statistic, Spin } from 'antd';
import { ProjectOutlined, FileTextOutlined, ShoppingOutlined, DollarOutlined } from '@ant-design/icons';

const SummaryCards = ({ data, loading, onClickProjects, onClickEstimates, onClickOrders, onClickInvoices }) => {
  if (loading) {
    return (
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {[1, 2, 3, 4].map((i) => (
          <Col xs={24} sm={12} lg={6} key={i}>
            <Card>
              <Spin />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  if (!data) {
    return null;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  };

  const cards = [
    {
      title: 'Projects',
      value: data.projects.active_count,
      icon: <ProjectOutlined style={{ fontSize: 24, color: '#1890ff' }} />,
      color: '#1890ff',
      clickable: true,
      onClick: onClickProjects,
      suffix: (
        <div style={{ fontSize: 14, color: '#1890ff', marginTop: 8, cursor: 'pointer' }}>
          Click to show project breakdown
        </div>
      ),
    },
    {
      title: 'Estimates',
      value: data.estimates.total_count,
      icon: <FileTextOutlined style={{ fontSize: 24, color: '#fa8c16' }} />,
      color: '#fa8c16',
      clickable: true,
      onClick: onClickEstimates,
      suffix: (
        <div style={{ fontSize: 14, color: '#fa8c16', marginTop: 8, cursor: 'pointer' }}>
          Click to show estimate breakdown
        </div>
      ),
    },
    {
      title: 'Orders',
      value: data.orders.total_count,
      icon: <ShoppingOutlined style={{ fontSize: 24, color: '#52c41a' }} />,
      color: '#52c41a',
      clickable: true,
      onClick: onClickOrders,
      suffix: (
        <div style={{ fontSize: 14, color: '#52c41a', marginTop: 8, cursor: 'pointer' }}>
          Click to show order breakdown
        </div>
      ),
    },
    {
      title: 'Invoices',
      value: data.invoices.total_count,
      icon: <DollarOutlined style={{ fontSize: 24, color: '#722ed1' }} />,
      color: '#722ed1',
      clickable: true,
      onClick: onClickInvoices,
      suffix: (
        <div style={{ fontSize: 14, color: '#722ed1', marginTop: 8, cursor: 'pointer' }}>
          Click to show invoice breakdown
        </div>
      ),
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      {cards.map((card, index) => (
        <Col xs={24} sm={12} lg={6} key={index}>
          <Card
            hoverable
            onClick={card.clickable ? card.onClick : undefined}
            style={{
              borderTop: `3px solid ${card.color}`,
              height: '100%',
              cursor: card.clickable ? 'pointer' : 'default',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
              {card.icon}
              <span style={{ marginLeft: 12, fontSize: 16, fontWeight: 500 }}>
                {card.title}
              </span>
            </div>
            <Statistic
              value={card.value}
              valueStyle={{ color: card.color, fontSize: 32, fontWeight: 'bold' }}
            />
            {card.suffix}
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default SummaryCards;
